import {
  buildBaseHeaders,
  handleUrl,
  myHeadersWithTokenContentType,
} from '../global';
import { LoginLayoutProps, LoginParams, LoginProps } from './types';

export const login = ({
  email,
  password,
}: LoginParams): Promise<LoginProps> => {
  const myHeaders = buildBaseHeaders();
  myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');

  const urlencoded = new URLSearchParams();
  urlencoded.append('username', email);
  urlencoded.append('password', password);

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: urlencoded,
  };

  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/login/control`, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => new Error(error));
};

export const getLoginLayout = (): Promise<LoginLayoutProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };

  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/login`, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => new Error(error));
};
